export default __webpack_public_path__ + "static/video01-7873f30d5be06ce824b826e1dd99a276.jpg";